import { StoreService } from './../store.service';
import { AfterViewInit, Component, EventEmitter, NgModule, OnInit, Output } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { AuthenticationService } from '../../core/service/auth.service';
import { MyprofileService } from '../../core/service/myprofile.service';
import { PropertyService } from '../../core/service/property.service';
import { PropertyDropDown } from '../../shared/models/property-dd.model';
import { MessagingService } from './../messaging.service';

declare var $: any;
@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})

@NgModule({

})
export class NavigationComponent implements AfterViewInit, OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();
  propertyListSub;
  selectProp: string;
  private notificationSub: Subscription;
  public config: PerfectScrollbarConfigInterface = {};
  currentMessage = new BehaviorSubject(null);
  constructor(
    private modalService: NgbModal,
    private propertyServ: PropertyService,
    private auth: AuthenticationService,
    private router: Router,
    private sanitizer: DomSanitizer, private storeService: StoreService, private myprofileService: MyprofileService, private angularFireMessaging: AngularFireMessaging, private messagingService: MessagingService) { }

  public showSearch = false;
  public username;
  imagepreview: any = "assets/images/big/icon-user-default.png"
  isloading;
  active = true;
  public useremail;
  public defaultProp;
  private propertyDD: PropertyDropDown[] = [];
  private propertyDDUpdated = new Subject<{ propertyDD: PropertyDropDown[]; }>();
  notifications: Object[] = [];
  blink = false;
  message;
  showMenu1 = '';

  propListDropDown() {
    this.propertyServ.getPropertyList();
    this.propertyServ.getpropertyListListner()
      .subscribe((propertyListData: { propertyDD: PropertyDropDown[]; }) => {
        this.propertyListSub = propertyListData.propertyDD;
        // console.log(this.propertyListSub);
        for (let i = 0; i < propertyListData.propertyDD.length; i++) {
          if (propertyListData.propertyDD[i].Default == "Yes") {
            this.defaultProp = propertyListData.propertyDD[i].id;
            localStorage.setItem("propertyId", this.defaultProp);
            localStorage.setItem("selectedPropertyFrequency", propertyListData.propertyDD[i].RentFrequency);
          }
        }
        if (this.propertyListSub.length == 0) {
          localStorage.removeItem("propertyId");
          this.router.navigate(['./webapps/properties']);
        }
      });
  }

  getuserName() {                                 //user name implemented by Gaurav
    this.auth.getusername();
    this.auth.getUsernameListner()
      .subscribe((data: { Name: string; Email: string, SigningWay: string, Picture: string }) => {
        this.username = data.Name;
        this.useremail = data.Email
        // if (data.SigningWay == "google") {
        //   this.imagepreview = data.Picture;
        //   if (data.Picture == undefined || data.Picture == null) {
        //     this.imagepreview = "assets/images/big/icon-user-default.png";
        //   }
        // }
      });
  }

  getuserimage() {
    this.myprofileService.getmyProfileData().subscribe(profile => {
      if (profile.Ref_FileId != null) {
        this.myprofileService.getmyProfileImageData(profile.Ref_FileId)
          .subscribe(Response => {
            // console.log(Response)
            var ImageData = Response.Response["ImageData"];
            // console.log("File Id is: - " + ImageData);
            this.imagepreview = this.sanitizer.bypassSecurityTrustUrl(ImageData);
            this.isloading = true;
          });
      }
      else {
        this.imagepreview = "assets/images/big/icon-user-default.png"
        if (profile.myProfileView[0].SigningWay == "google") {
          this.imagepreview = profile.myProfileView[0].Picture;
          if (profile.myProfileView[0].Picture == undefined || profile.myProfileView[0].Picture == null) {
            this.imagepreview = "assets/images/big/icon-user-default.png";
          }
        }
        this.isloading = true;
      }
    });
  }

  ngOnInit() {
    this.getuserName();
    this.getuserimage();

    this.storeService.isProfileUpdated()
      .subscribe(response => {
        if (response) {
          this.getuserimage();
        }
      })
    this.propListDropDown();
    // this.getAllNotification();

    const userId = localStorage.getItem("userId");//"user001"
    this.messagingService.requestPermission(userId)
    this.messagingService.receiveMessage();

    if (localStorage.getItem("IsNotifReceived") == "Y") {
      this.blink = true;
    }
    else {
      this.blink = false;
    }

    this.message = this.messagingService.currentMessage
    this.messagingService.currentMessage
      .subscribe(response => {
        if (response != null) {
          this.blink = true
        }
      })
  }

  getAllNotification() {
    this.notificationSub = this.auth.getAllNotification()
      .subscribe(response => {
        this.notifications = []
        if (response.code == "1000") {
          // this.isNotifChecked = true;
          this.blink = false
          localStorage.setItem("IsNotifReceived", "N");
          response.UserNotifications.forEach(element => {
            const title: String = element.notification.title
            element.notification.icon = "assets/images/Maintenance/rb_" + title.toLowerCase() + ".png"
            this.notifications.push(element)
            //console.log(this.notifications)
          });
        }
      })
  }

  onSelectProperty(value) {
    this.propertyServ.saveSelectedProperty(value);
  }

  logout() {
    event.preventDefault();
    this.auth.logout();
  }

  myprofile() {
    this.router.navigate(["./webapps/user-profile/my-profile"]);
    this.active = !this.active;
  }

  accountsetting() {
    //this.router.navigate(["./webapps/update-password"]);
  }

  getPerticularNotification(id) {
    //console.log("getPerticularNotification");
    const Id = id
    this.router.navigate(['./webapps/tickets-new/' + Id]);
  }

  addExpandClass1(element: any) {
    if (element === this.showMenu1) {
      this.showMenu1 = '0';
    } else {
      this.showMenu1 = element;
    }
  }

  ngAfterViewInit() { }
  // ngOnDestroy() {
  //   this.notifications = []
  //   this.notificationSub.unsubscribe();
  // }
}